module.exports = __webpack_public_path__ + "static/img/halo.99af400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/halo.png
// module id = iXMg
// module chunks = 36